import { Reveal, Eyebrow } from "./Reveal";
import { RequestButton, WhatsAppButton } from "./Buttons";
import { PROCESS } from "@/content/site";

export default function Process() {
  return (
    <section className="relative py-20 md:py-32 border-b border-[var(--line)] overflow-hidden" data-testid="process-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <Eyebrow n="03">How enquiries work</Eyebrow>
              <h2 className="mt-5 font-display font-black uppercase text-5xl md:text-7xl leading-[0.9]">Four<br />simple<br /><span className="text-[var(--red)]">steps</span></h2>
              <p className="mt-6 text-sm md:text-base text-[var(--grey)] leading-relaxed max-w-sm">No accounts, no booking fees. Just tell us about the tool and we'll take it from there.</p>
            </Reveal>
          </div>
        </div>
        <ol className="lg:col-span-8 border-t border-[var(--line)]">
          {PROCESS.map((p, i) => (
            <Reveal as="li" key={p.n} delay={i * 0.05} className="group grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-8 md:py-10 border-b border-[var(--line)]">
              <span className="font-mono text-sm text-[var(--red)] pt-2" data-testid={`process-step-${p.n}`}>{p.n}</span>
              <div>
                <h3 className="font-display font-extrabold uppercase text-3xl md:text-5xl transition-transform duration-500 group-hover:translate-x-2">{p.title}</h3>
                <p className="mt-3 text-sm md:text-base text-[var(--grey)] leading-relaxed max-w-xl">{p.text}</p>
              </div>
            </Reveal>
          ))}
          <div className="pt-10 flex flex-col sm:flex-row gap-3">
            <RequestButton testId="process-request-repair-btn" />
            <WhatsAppButton testId="process-whatsapp-btn" />
          </div>
        </ol>
      </div>
    </section>
  );
}
